import axios from "axios";

const uploadLimitsUrl = "/api/cmms/upload-limits";

const throwResponseData = (error) => {
  throw error.response?.data ?? error;
};

/**
 * The size and content-type limits the server actually enforces.
 *
 * Fetched rather than hardcoded so the client cannot drift from the server when the
 * configured ceiling moves.
 */
export const getCmmsUploadLimits = async () => {
  try {
    const response = await axios.get(uploadLimitsUrl);
    return response.data;
  } catch (error) {
    return throwResponseData(error);
  }
};
